import ctl from "@netlify/classnames-template-literals";

export const panel = ctl(`
  flex
  w-full
  flex-col
  items-center
`);
